import { ReactNode } from 'react';

export type BlankLayoutProps = {
  children: ReactNode;
  className?: string;
};

export const BlankLayout = ({ children, className }: BlankLayoutProps) => {
  return <div className={className}>{children}</div>;
};
